// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0;
}

.custom-card {
  border: 0;
  border-radius: 16px;
  padding: 32px 52px;
  box-shadow: 0px 46px 66px 0px rgba(0, 0, 0, 0.1);
}

.main-heading h1 {
  font-size: 32px;
  font-weight: 700;
  color: #003848;
}

.main-heading h1 span {
  color: #afb3b6;
}

.custom-card h2 {
  font-size: 42px;
  font-weight: 700;
  color: #003848;
  line-height: 24px;
  margin-bottom: 16px;
}

.custom-card p {
  color: #6d7175;
  font-weight: 400;
  font-size: 14px;
}

.custom-card form .custom-input input {
  border-radius: 12px;
  padding: 16px 40px;
  border-color: #d0d5dd;
  font-size: 16px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.custom-card form .custom-input .prefix-icon {
  position: absolute;
  top: 30%;
  left: 10px;
}

.custom-card .form-check .form-check-label {
  font-size: 12px;
  color: #afb3b6;
}

.custom-card .btn-link {
  font-size: 12px;
  text-decoration: none;
}

.custom-card .btn.logged-in,
.settings-password-content button.logged-in {
  border-radius: 12px;
  background-color: #003848;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  padding: 16px;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
}

.custom-card .form-check-input:checked {
  background-color: #003847;
  border-color: #003847;
}

.custom-card .form-check-input:focus {
  border-color: #003847;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(0 56 71 / 27%);
}

.profile-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #003848;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #ffffff;
  font-weight: 500;
}

.profile-image .initials {
  text-transform: uppercase;
}

.sidebar {
  padding: 60px 0 0;
  background: #003848;
  position: sticky;
  top: 0;
  border-radius: 0 20px 20px 0;
  width: 100%;
  height: 100vh;
  margin-left: -15px;
}

.sidebar .sidebar-content {
  margin: 0 20px;
}

.sidebar .sidebar-content h1 {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 80px;
}

.sidebar .sidebar-content ul li a {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  display: flex;
  align-items: center;
  font-weight: 400;
  line-height: 24px;
  padding: 10px;
  margin: 10px 0px;
  width: 100%;
}

.sidebar .sidebar-content ul li a.active {
  border-radius: 12px;
  color: #000;
  background: #fff;
}

.header {
  border-radius: 0px 0px 12px 12px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  padding: 17px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.sidebar .sidebar-content ul li a.active svg path {
  fill: rgba(33, 174, 133, 1);
}

.sidebar .sidebar-content ul li a svg path {
  fill: #ffffff;
}

.sidebar .sidebar-content ul li a svg {
  margin-right: 10px;
  width: 18px;
}

.sidebar .logout-btn {
  background: #fff;
  border-radius: 0 0 12px 0;
  padding: 40px;
}

.sidebar .logout-btn button {
  color: #02005f;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration: none;
  padding: 0;
}

.sidebar .logout-btn svg {
  margin-right: 10px;
}

.page-header-filter button svg {
  margin-left: 15px;
}

.page-header-filter button {
  border-radius: 12px;
  border: 1px solid #eaeaea;
  background: #fff;
  color: #000;
  padding: 15px 30px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.page-header-filter button:hover,
.page-header-filter button:hover {
  background-color: #003848;
  border-color: #003848;
}

.page-header-filter button:hover svg path {
  stroke: #fff;
}

.page-header-filter-list {
  position: absolute;
  top: 65px;
  background: #fff;
  width: 100%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  z-index: 999;
  overflow: hidden;
}

.page-header-filter-list ul li {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  text-transform: capitalize;
  font-weight: 500;
  color: #003848;
  transition: all 0.4s;
  cursor: pointer;
}

.page-header-filter-list ul li:hover,
.page-header-filter-list ul li.active {
  background: #003848;
  color: #ffffff;
}

.page-header-filter-list ul li:last-child {
  border: 0;
}

.page-header-title h2 {
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.page-header-search input {
  border-radius: 12px;
  background: #fff;
  padding: 14px 50px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 400px;
  border: 1px solid #eaeaea;
}

.page-header-search .search-icon-div {
  top: 26%;
  left: 14px;
}

.dashboard-table {
  max-width: 1400px;
  margin: 0 auto;
}

.dashboard-table table {
  border-radius: 16px;
  background: #fff;
  width: 100%;
}

.dashboard-table table tr {
  border-bottom: 1px solid #e7e7e7;
}

.dashboard-table table tbody tr:last-child {
  border-bottom: 0;
}

.dashboard-table table tr th,
.dashboard-table table tr td {
  padding: 12px 15px;
}

.dashboard-table table tr th {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.dashboard-table table tr td,
.dashboard-table table tr td h5 {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.table-pagination span {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.dashboard-table table tr td .active-badge {
  background: #e3ffbf !important;
}

.in-progress-badge {
  background-color: #fff2ad !important;
}

.dashboard-table .paused-badge {
  background: #eaeaea !important;
}

.dashboard-table .badge,
.customer-modal-details .badge {
  border-radius: 30px !important;
  padding: 9px 18px;
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
}

.bg-danger.badge {
  background-color: rgba(255, 88, 74, 1) !important;
  color: #fff !important;
}

.dashboard-table table tr td,
.dashboard-table table tr th {
  border-right: 1px solid #e7e7e7;
}

.dashboard-table table tr td img {
  width: 60px;
  border: 1px dashed #d0d5dd;
}

.dashboard-table table tr td:last-child,
.dashboard-table table tr th:last-child {
  border-right: 0;
}

.dashboard-table table tr td .page-header-filter-list {
  top: 35px;
}

.campaign-details {
  border-radius: 26px;
  background: #fff;
  padding: 35px;
}

.campaign-details h2 {
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 20px;
}

.campaign-details p {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 0;
}

.campaign-details table {
  border: 1px solid #e7e7e7;
}

.campaign-details button.btn-secondary,
.modal-content .modal-footer .btn-secondary,
.modal-content .modal-footer .light-btn {
  border-radius: 12px;
  border: 1px solid #eaeaea;
  background: #003848;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #fff;
  padding: 15px 30px;
  margin: 20px 0;
}

.campaign-details button.btn-secondary:hover,
.modal-content .modal-footer .btn-secondary:hover {
  background: #ffffff;
  color: #003848;
  border-color: #003848;
}

.campaign-details .campaign-details-customer h3,
.settings-tab-content h6 {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.campaign-details .campaign-details-customer {
  padding: 10px 0;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
}

.card-container .card {
  padding: 15px 20px;
  width: 230px;
}

.card-container h4 {
  font-size: 21px;
  font-style: normal;
  margin: 15px 0;
  font-weight: 500;
  line-height: 24px;
}

.card-container span {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #adadad;
}

.card-container .card.sent rect {
  fill: #ffecec;
}

.card-container .card.sent path {
  fill: rgba(255, 88, 74, 1);
}

.campaign-details .campaign-design-text p {
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 41px;
  max-width: 330px;
}

.customer-status-drop {
  max-width: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.campaign-design img {
  width: 300px;
  border: 1px dashed #003848;
  height: 180px;
  object-fit: contain;
}

.campaign-design .paused-badge,
.campaign-details-customer .paused-badge,
.customer-modal-details .badge {
  border-radius: 6px !important;
  background: #cbcbcb !important;
}

.address-col {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 300px;
  overflow: hidden;
  display: block;
}

.modal-dialog {
  max-width: 600px;
}

.modal-dialog .modal-content {
  border-radius: 12px;
  border: 0;
}

.modal-dialog .modal-header {
  border: 0;
  padding: 25px 30px 0;
}

.modal-dialog .modal-header .modal-title {
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 15px;
}

.customer-modal-content p,
.customer-setting-content p {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
}

.customer-modal-content p:first-child,
.customer-setting-content p:first-child {
  max-width: 150px;
  width: 100%;
}

.customer-setting-content button {
  line-height: 0;
}

.customer-modal-details {
  max-width: 480px;
  margin: 20px auto;
}

.customer-modal-details .customer-modal-content,
.customer-setting-content {
  border-bottom: 1px solid #ebebeb;
  padding: 10px 0;
}

.customer-modal-details h5 {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin: 20px 0;
}

.modal-content .modal-footer {
  border: 0;
  padding-top: 0;
}

.modal-content .modal-footer button.btn {
  margin-top: 0;
}

.modal-content .modal-footer .light-btn {
  background: #f4f4f4;
  color: #003848;
  margin-right: 10px;
}

.modal-content .modal-footer .light-btn:hover {
  background: #003848;
  color: #f4f4f4;
}

.settings-tab-content {
  padding: 24px;
  background: #fff;
  border-radius: 9px;
  border: 1px solid #d7d7d7;
  min-width: 175px;
  max-width: 250px;
  width: 100%;
  cursor: pointer;
}

.settings-tab-content.active {
  box-shadow: 0px 7px 0px 0px #003848;
}

.settings-profile-content {
  padding: 20px;
  border-radius: 12px;
  background: #fff;
}

.settings-profile-content > p {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.settings-profile-content .profile-image {
  width: 110px;
  height: 105px;
  font-size: 30px;
}

.settings-password-content {
  max-width: 450px;
  margin: auto;
  position: relative;
}

.settings-password-content h2 {
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
  margin-bottom: 34px;
  margin-top: 50px;
}

.settings-password-content input,
.campaign-postcard-amount input {
  padding: 16px;
  background: transparent;
  margin-bottom: 12px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #003848;
}

.campaign-postcard-amount input {
  padding: 13px;
  margin: 0;
  border-radius: 12px;
}

.input-error {
  position: absolute;
  top: 60px;
  left: 0;
  font-size: 14px;
  color: #ff2525;
}

.alert {
  left: 50%;
  transform: translate(-50%, -60px);
  max-width: 500px;
}

.dashboard-table table tr td .empty-view h5 {
  font-size: 22px;
  font-weight: 600;
  margin: 10px 0;
  color: #003848;
}

.dashboard-table table tr td .empty-view p {
  font-size: 16px;
  color: #7f7f7f;
  margin-bottom: 10px;
}

.campaign-postcard-amount label {
  font-size: 12px;
}

.loader {
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  border-top: 8px solid #003848;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

/* Safari */

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.global-loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
}

.global-loader > div {
  align-items: center;
  height: 90%;
}

.login-error {
  top: 75px;
}

.card-container .card.production path {
  fill: #009717;
}

.card-container .card.production rect {
  fill: #00971721;
}

.settings-modal.modal-dialog {
  max-width: 450px;
}

.row {
  display: flex;
}

.cell {
  width: 30px;
  height: 25px;
  background-color: #ccc;
  animation: pulse 1s infinite alternate;
}

@keyframes pulse {
  from {
    opacity: 0.6;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA,WAAW;;AAUX;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["h1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 0;\n}\n\n.custom-card {\n  border: 0;\n  border-radius: 16px;\n  padding: 32px 52px;\n  box-shadow: 0px 46px 66px 0px rgba(0, 0, 0, 0.1);\n}\n\n.main-heading h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #003848;\n}\n\n.main-heading h1 span {\n  color: #afb3b6;\n}\n\n.custom-card h2 {\n  font-size: 42px;\n  font-weight: 700;\n  color: #003848;\n  line-height: 24px;\n  margin-bottom: 16px;\n}\n\n.custom-card p {\n  color: #6d7175;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.custom-card form .custom-input input {\n  border-radius: 12px;\n  padding: 16px 40px;\n  border-color: #d0d5dd;\n  font-size: 16px;\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.custom-card form .custom-input .prefix-icon {\n  position: absolute;\n  top: 30%;\n  left: 10px;\n}\n\n.custom-card .form-check .form-check-label {\n  font-size: 12px;\n  color: #afb3b6;\n}\n\n.custom-card .btn-link {\n  font-size: 12px;\n  text-decoration: none;\n}\n\n.custom-card .btn.logged-in,\n.settings-password-content button.logged-in {\n  border-radius: 12px;\n  background-color: #003848;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 16px;\n}\n\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px white inset;\n}\n\n.custom-card .form-check-input:checked {\n  background-color: #003847;\n  border-color: #003847;\n}\n\n.custom-card .form-check-input:focus {\n  border-color: #003847;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgb(0 56 71 / 27%);\n}\n\n.profile-image {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #003848;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.profile-image .initials {\n  text-transform: uppercase;\n}\n\n.sidebar {\n  padding: 60px 0 0;\n  background: #003848;\n  position: sticky;\n  top: 0;\n  border-radius: 0 20px 20px 0;\n  width: 100%;\n  height: 100vh;\n  margin-left: -15px;\n}\n\n.sidebar .sidebar-content {\n  margin: 0 20px;\n}\n\n.sidebar .sidebar-content h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 80px;\n}\n\n.sidebar .sidebar-content ul li a {\n  color: #fff;\n  font-family: Inter;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  line-height: 24px;\n  padding: 10px;\n  margin: 10px 0px;\n  width: 100%;\n}\n\n.sidebar .sidebar-content ul li a.active {\n  border-radius: 12px;\n  color: #000;\n  background: #fff;\n}\n\n.header {\n  border-radius: 0px 0px 12px 12px;\n  background: #fff;\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);\n  padding: 17px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.sidebar .sidebar-content ul li a.active svg path {\n  fill: rgba(33, 174, 133, 1);\n}\n\n.sidebar .sidebar-content ul li a svg path {\n  fill: #ffffff;\n}\n\n.sidebar .sidebar-content ul li a svg {\n  margin-right: 10px;\n  width: 18px;\n}\n\n.sidebar .logout-btn {\n  background: #fff;\n  border-radius: 0 0 12px 0;\n  padding: 40px;\n}\n\n.sidebar .logout-btn button {\n  color: #02005f;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  text-decoration: none;\n  padding: 0;\n}\n\n.sidebar .logout-btn svg {\n  margin-right: 10px;\n}\n\n.page-header-filter button svg {\n  margin-left: 15px;\n}\n\n.page-header-filter button {\n  border-radius: 12px;\n  border: 1px solid #eaeaea;\n  background: #fff;\n  color: #000;\n  padding: 15px 30px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.page-header-filter button:hover,\n.page-header-filter button:hover {\n  background-color: #003848;\n  border-color: #003848;\n}\n\n.page-header-filter button:hover svg path {\n  stroke: #fff;\n}\n\n.page-header-filter-list {\n  position: absolute;\n  top: 65px;\n  background: #fff;\n  width: 100%;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  z-index: 999;\n  overflow: hidden;\n}\n\n.page-header-filter-list ul li {\n  border-bottom: 1px solid #ccc;\n  padding: 10px;\n  text-transform: capitalize;\n  font-weight: 500;\n  color: #003848;\n  transition: all 0.4s;\n  cursor: pointer;\n}\n\n.page-header-filter-list ul li:hover,\n.page-header-filter-list ul li.active {\n  background: #003848;\n  color: #ffffff;\n}\n\n.page-header-filter-list ul li:last-child {\n  border: 0;\n}\n\n.page-header-title h2 {\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n}\n\n.page-header-search input {\n  border-radius: 12px;\n  background: #fff;\n  padding: 14px 50px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  width: 400px;\n  border: 1px solid #eaeaea;\n}\n\n.page-header-search .search-icon-div {\n  top: 26%;\n  left: 14px;\n}\n\n.dashboard-table {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.dashboard-table table {\n  border-radius: 16px;\n  background: #fff;\n  width: 100%;\n}\n\n.dashboard-table table tr {\n  border-bottom: 1px solid #e7e7e7;\n}\n\n.dashboard-table table tbody tr:last-child {\n  border-bottom: 0;\n}\n\n.dashboard-table table tr th,\n.dashboard-table table tr td {\n  padding: 12px 15px;\n}\n\n.dashboard-table table tr th {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.dashboard-table table tr td,\n.dashboard-table table tr td h5 {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.table-pagination span {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.dashboard-table table tr td .active-badge {\n  background: #e3ffbf !important;\n}\n\n.in-progress-badge {\n  background-color: #fff2ad !important;\n}\n\n.dashboard-table .paused-badge {\n  background: #eaeaea !important;\n}\n\n.dashboard-table .badge,\n.customer-modal-details .badge {\n  border-radius: 30px !important;\n  padding: 9px 18px;\n  color: #000;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.bg-danger.badge {\n  background-color: rgba(255, 88, 74, 1) !important;\n  color: #fff !important;\n}\n\n.dashboard-table table tr td,\n.dashboard-table table tr th {\n  border-right: 1px solid #e7e7e7;\n}\n\n.dashboard-table table tr td img {\n  width: 60px;\n  border: 1px dashed #d0d5dd;\n}\n\n.dashboard-table table tr td:last-child,\n.dashboard-table table tr th:last-child {\n  border-right: 0;\n}\n\n.dashboard-table table tr td .page-header-filter-list {\n  top: 35px;\n}\n\n.campaign-details {\n  border-radius: 26px;\n  background: #fff;\n  padding: 35px;\n}\n\n.campaign-details h2 {\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  margin-bottom: 20px;\n}\n\n.campaign-details p {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  margin-bottom: 0;\n}\n\n.campaign-details table {\n  border: 1px solid #e7e7e7;\n}\n\n.campaign-details button.btn-secondary,\n.modal-content .modal-footer .btn-secondary,\n.modal-content .modal-footer .light-btn {\n  border-radius: 12px;\n  border: 1px solid #eaeaea;\n  background: #003848;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  color: #fff;\n  padding: 15px 30px;\n  margin: 20px 0;\n}\n\n.campaign-details button.btn-secondary:hover,\n.modal-content .modal-footer .btn-secondary:hover {\n  background: #ffffff;\n  color: #003848;\n  border-color: #003848;\n}\n\n.campaign-details .campaign-details-customer h3,\n.settings-tab-content h6 {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.campaign-details .campaign-details-customer {\n  padding: 10px 0;\n  border-top: 1px solid #ebebeb;\n  border-bottom: 1px solid #ebebeb;\n}\n\n.card-container .card {\n  padding: 15px 20px;\n  width: 230px;\n}\n\n.card-container h4 {\n  font-size: 21px;\n  font-style: normal;\n  margin: 15px 0;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.card-container span {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  color: #adadad;\n}\n\n.card-container .card.sent rect {\n  fill: #ffecec;\n}\n\n.card-container .card.sent path {\n  fill: rgba(255, 88, 74, 1);\n}\n\n.campaign-details .campaign-design-text p {\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 41px;\n  max-width: 330px;\n}\n\n.customer-status-drop {\n  max-width: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n\n.campaign-design img {\n  width: 300px;\n  border: 1px dashed #003848;\n  height: 180px;\n  object-fit: contain;\n}\n\n.campaign-design .paused-badge,\n.campaign-details-customer .paused-badge,\n.customer-modal-details .badge {\n  border-radius: 6px !important;\n  background: #cbcbcb !important;\n}\n\n.address-col {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 300px;\n  overflow: hidden;\n  display: block;\n}\n\n.modal-dialog {\n  max-width: 600px;\n}\n\n.modal-dialog .modal-content {\n  border-radius: 12px;\n  border: 0;\n}\n\n.modal-dialog .modal-header {\n  border: 0;\n  padding: 25px 30px 0;\n}\n\n.modal-dialog .modal-header .modal-title {\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  margin-top: 15px;\n}\n\n.customer-modal-content p,\n.customer-setting-content p {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n}\n\n.customer-modal-content p:first-child,\n.customer-setting-content p:first-child {\n  max-width: 150px;\n  width: 100%;\n}\n\n.customer-setting-content button {\n  line-height: 0;\n}\n\n.customer-modal-details {\n  max-width: 480px;\n  margin: 20px auto;\n}\n\n.customer-modal-details .customer-modal-content,\n.customer-setting-content {\n  border-bottom: 1px solid #ebebeb;\n  padding: 10px 0;\n}\n\n.customer-modal-details h5 {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  margin: 20px 0;\n}\n\n.modal-content .modal-footer {\n  border: 0;\n  padding-top: 0;\n}\n\n.modal-content .modal-footer button.btn {\n  margin-top: 0;\n}\n\n.modal-content .modal-footer .light-btn {\n  background: #f4f4f4;\n  color: #003848;\n  margin-right: 10px;\n}\n\n.modal-content .modal-footer .light-btn:hover {\n  background: #003848;\n  color: #f4f4f4;\n}\n\n.settings-tab-content {\n  padding: 24px;\n  background: #fff;\n  border-radius: 9px;\n  border: 1px solid #d7d7d7;\n  min-width: 175px;\n  max-width: 250px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.settings-tab-content.active {\n  box-shadow: 0px 7px 0px 0px #003848;\n}\n\n.settings-profile-content {\n  padding: 20px;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.settings-profile-content > p {\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n}\n\n.settings-profile-content .profile-image {\n  width: 110px;\n  height: 105px;\n  font-size: 30px;\n}\n\n.settings-password-content {\n  max-width: 450px;\n  margin: auto;\n  position: relative;\n}\n\n.settings-password-content h2 {\n  font-size: 42px;\n  font-style: normal;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 34px;\n  margin-top: 50px;\n}\n\n.settings-password-content input,\n.campaign-postcard-amount input {\n  padding: 16px;\n  background: transparent;\n  margin-bottom: 12px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  color: #003848;\n}\n\n.campaign-postcard-amount input {\n  padding: 13px;\n  margin: 0;\n  border-radius: 12px;\n}\n\n.input-error {\n  position: absolute;\n  top: 60px;\n  left: 0;\n  font-size: 14px;\n  color: #ff2525;\n}\n\n.alert {\n  left: 50%;\n  transform: translate(-50%, -60px);\n  max-width: 500px;\n}\n\n.dashboard-table table tr td .empty-view h5 {\n  font-size: 22px;\n  font-weight: 600;\n  margin: 10px 0;\n  color: #003848;\n}\n\n.dashboard-table table tr td .empty-view p {\n  font-size: 16px;\n  color: #7f7f7f;\n  margin-bottom: 10px;\n}\n\n.campaign-postcard-amount label {\n  font-size: 12px;\n}\n\n.loader {\n  border: 8px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 8px solid #003848;\n  width: 50px;\n  height: 50px;\n  animation: spin 2s linear infinite;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.global-loader {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.3);\n}\n\n.global-loader > div {\n  align-items: center;\n  height: 90%;\n}\n\n.login-error {\n  top: 75px;\n}\n\n.card-container .card.production path {\n  fill: #009717;\n}\n\n.card-container .card.production rect {\n  fill: #00971721;\n}\n\n.settings-modal.modal-dialog {\n  max-width: 450px;\n}\n\n.row {\n  display: flex;\n}\n\n.cell {\n  width: 30px;\n  height: 25px;\n  background-color: #ccc;\n  animation: pulse 1s infinite alternate;\n}\n\n@keyframes pulse {\n  from {\n    opacity: 0.6;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
